import { render, staticRenderFns } from "./ListProductVariances.vue?vue&type=template&id=1d10f1d8"
import script from "./ListProductVariances.vue?vue&type=script&lang=js"
export * from "./ListProductVariances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports